function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("circle", {
  cx: 2.11394,
  cy: 2.11408,
  r: 2.11394,
  transform: "rotate(-90 2.11394 2.11408)",
  fill: "#333333"
});

var _ref3 = /*#__PURE__*/React.createElement("circle", {
  cx: 8.97869,
  cy: 2.11408,
  r: 2.11394,
  transform: "rotate(-90 8.97869 2.11408)",
  fill: "#333333"
});

var _ref4 = /*#__PURE__*/React.createElement("circle", {
  cx: 15.8439,
  cy: 2.11408,
  r: 2.11394,
  transform: "rotate(-90 15.8439 2.11408)",
  fill: "#333333"
});

function SvgAgentactionbutton(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 5,
    viewBox: "0 0 18 5",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3, _ref4);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAgentactionbutton);
export default __webpack_public_path__ + "static/media/agentactionbutton.5f39ba6216873bdb09abf41b4d20f51f.svg";
export { ForwardRef as ReactComponent };